module.exports = __webpack_public_path__ + "img/booking-mobile.de5916fd.png";